<template>
  <div class="w-100 m-single-product-305 border  ">
    <m-single-product-wrapper :product-link="productLink" @product="dataReady">
      <template v-slot="{product}">

        <div class="row">
          <div class="col-12 p-0 m-0 mb-1">
            <single-product-gallery1 class=" m-single-product-305-gallery" :product="product"
                                     :gallery-full-slider="galleryFullSlider"/>
          </div>
          <div class="col-12 p-2">
            <div class="m-single-product-305-title flex flex-column">
              <div class="d-inline-block" v-for="category in product.category">
                <m-a :href="{name:'Products',query:{category_column:'slug',category:category.slug}}"
                     class="m-single-product-305-category1  mx-1">
                  <span class="m-single-product-305-label">{{ `${category.name} /` }}</span>
                </m-a>
              </div>
              <div class="row">
                <div class="col-6">
                  <h1 class="m-single-product-305-title mt-2">{{ product.name }}</h1>
                </div>
                <div class="col-6 text-left">
                  <h6 class="m-single-product-305-title h1 mt-2" v-if="product.user">آگهی دهنده: {{ product.user.name }}
                    {{ product.user.last_name }}</h6>
                </div>
              </div>
            </div>
            <hr>
            <div class="justify-content-center text-center align-items-center row">
              <div class="col-lg-4 my-1" v-if="chatAvailable">
                <m-chat-widget2 :product="product"/>
              </div>
              <div class="col-lg-4 my-1" v-if="showUserCellphone">


                <div @click="manageCellphone(product)" class="btn btn-primary rounded-pill">
                  تماس با آگهی دهنده
                </div>

                <template v-if="productUserCellphone.length > 0">
                  <a :href="`tel:${productUserCellphone}`" class="btn d-block btn-sm my-1 btn-primary rounded-pill">
                    {{ productUserCellphone }}
                  </a>
                </template>


              </div>
              <div class="col-lg-4 my-1" v-if="Object.keys(product).length > 0 && requestOrder">

                <m-product-card-quantity-manager1 :in-active-quantity-manager="true"
                                                  :setUnauthenticatedShoppingCartFromLoginUser="true"
                                                  :redirect-after-add-digital-product="true"
                                                  :show-modal-if-product-category-inside-cash-on-delivery="true"
                                                  class=" my-1"
                                                  :product="product"/>
              </div>
              <div class="col-lg-4 my-1" v-if="!requestOrder">
                <m-single-product-price3 class="text-center" :product="product"/>
              </div>

            </div>
            <hr>
            <div class="m-single-product-305-content text-center ">
              <div class="row">
                <div class="col-lg-3 col-md-4 my-2" v-for="productFeature in productTableFeature(product)">
                  <div class="m-single-product-305-content-feat col-12">
                    <div class="m-single-product-305-content-feat-title ">
                   <span class="">
                     {{ productFeatureName(product, productFeature.id) }}
                   </span>
                    </div>
                    <div class="">
                   <span class="">
                      {{ productFeatureValue(product, productFeature.id) }}
                   </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <slot name="p-1"></slot>
          </div>
          <div class="col-12" v-if="showViewCount">
            <product-view-count1 :product="product"/>
          </div>
        </div>
        <div class="row my-2">
          <div class="col-12">
            <div class="" v-html="product.description"></div>
          </div>
        </div>
        <div class="row" v-if="showLatestOrderFromProduct && Object.keys(product).length">
          <hr>
          <div class="col-12">
            <m-latest-order-of-product1 :product="product"/>
          </div>
        </div>
        <div class="row">
          <hr>
          <div class="col-12">
            <m-comment-archive-1 commentable_type="product" :commentable_id="product.id"/>
          </div>
        </div>
      </template>
    </m-single-product-wrapper>
  </div>
</template>

<script>
import mSingleProductWrapper from "../../Wrappers/SingleProductWrapper.vue";
import mSingleProductPriceWrapper from "../SingleProductPriceWrapper.vue";
import mH2 from "../../Tags/H2.vue";
import mA from "../../Tags/A.vue";
import mProductPrice100 from "../ProductPrice100.vue";
import mSingleProductPrice3 from "../SingleProductPrice3/SingleProductPrice3.vue";
import mProductSlider1 from "../ProductSlider/ProductSlider1.vue";
import mCourseCard1 from "../../Course/Card/CourseCard1.vue";
import mStoreCard310 from "../../MultipleStore/Card/StoreCard310.vue";
import mHtmlToComponentWrapper from "../../Wrappers/HtmlToComponentWrapper.vue";
import {Cards} from "../Card/Cards";
import SingleProductGallery1 from "./Components/SingleProductGallery1.vue";
import SingleProductDetail1 from "./Components/SingleProductDetail1.vue";
import mChatWidget2 from "../../Chat/Widget/ChatWidget2.vue";
import {
  productFeatureName,
  productFeatureValue,
  productTableFeature
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import mProductCardQuantityManager1 from "../QuantityManager/Card/ProductCardQuantityManager1.vue";
import mLatestOrderOfProduct1 from "../LatestOrderOfProduct/LatestOrderOfProduct1.vue";
import mCommentArchive1 from "../../Comment/Archive/CommentArchive1.vue";
import ProductViewCount1 from "../Component/ProductViewCount/ProductViewCount1.vue";

export default {
  name: "SingleProduct304",
  components: {
    ProductViewCount1,
    mCommentArchive1,
    mLatestOrderOfProduct1,
    mProductCardQuantityManager1,
    SingleProductDetail1,
    SingleProductGallery1,
    mSingleProductWrapper,
    mH2,
    mSingleProductPriceWrapper,
    mProductPrice100,
    mSingleProductPrice3,
    mProductSlider1,
    mA,
    mCourseCard1,
    mStoreCard310,
    mHtmlToComponentWrapper,
    mChatWidget2,
  },
  props: {
    productLink: {
      default: null
    },
    relatedProducts: {
      type: Boolean,
      default: true
    },
    productCardName: {
      options: Object.keys(Cards),
      default: 'mProductCard309',
    },
    relatedCourse: {
      type: Boolean,
      default: false,
    },
    galleryFullSlider: {
      type: Boolean,
      default: false
    },
    chatAvailable: {
      default: true,
      type: Boolean
    },
    requestOrder: {
      default: false,
      type: Boolean
    },
    showLatestOrderFromProduct: {
      default: false,
      type: Boolean
    },
    showUserCellphone: {
      default: false,
      type: Boolean
    },
    showViewCount: {
      default: false,
      type: Boolean
    },
    decreaseChargeFromProductOwnerWallet: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      productUserCellphone: ""
    };
  },
  methods: {
    productFeatureValue,
    productFeatureName,
    productTableFeature,
    dataReady(product) {

    },
    productCategories(product) {
      if (product.category != undefined) {
        let categories = product.category.map(item => {
          return item.slug;
        })

        return categories.length == 0 ? null : categories
      }

    },
    productBrands(product) {
      const brand = product.brand;
      return brand == null ? null : [brand.slug];
    },
    manageCellphone(product) {
      if (this.decreaseChargeFromProductOwnerWallet) {
        this.productUserCellphone = ''
        let form = {
          product_id: product.id
        }
        this.$store.dispatch('Product/decreaseValueForShowUserCellphone', form).then(res => {
          let data = res.data.data
          this.productUserCellphone = data.cellphone
          window.location.href = 'tel:' + this.productUserCellphone;
        })


      } else {
        this.productUserCellphone = product.user.cellphone;
        window.location.href = 'tel:' + this.productUserCellphone;
      }

    }
  },
  destroyed() {
    this.productUserCellphone = ''
  }
};
</script>

<style scoped>
.m-single-product-305 {
  border-radius: 1.1rem;
  box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
}

.m-single-product-305-category1 {
  color: var(--primary);
}

.m-single-product-305-title {
  color: #1d1d1d;
  font-size: 1.3rem;
}

.m-single-product-305-banner {
  border-radius: 1rem;
}

.m-single-product-305-content {
  width: 100%;
}

.m-single-product-305-label {
  font-size: 16px;
}

.m-single-product-305-content-feat {
  background-color: rgba(238, 238, 241, 0.97);
  border-radius: .8rem;
  padding: 14px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  font-size: 13px;
}

.m-single-product-305-content-feat-title {
  background-color: rgba(238, 238, 241, 0.97);
  font-weight: 14;
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}

.m-single-product-305-banner {
  font-size: 14px;
}


.m-single-product-305 :deep(.single-product-gallery-1) {
  height: 380px !important;
}

</style>